import { render } from "./notfound.vue?vue&type=template&id=01d79556"
import script from "./notfound.vue?vue&type=script&lang=js"
export * from "./notfound.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\maxcs.tan\\source\\repos\\IES-NameCard\\DigitalNamecard\\wwwroot\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__